'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.formOnFocusHandler = formOnFocusHandler;
exports.watchFormOnFocusEvents = watchFormOnFocusEvents;

var _immutable = require('redux-form/immutable');

var _effects = require('redux-saga/effects');

var _actions = require('../../actions');

var _analytics = require('../../analytics');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(formOnFocusHandler),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchFormOnFocusEvents);
//compatibility to versions up to 0.15 of redux-sage

/**
 * Process first form focus event
 * @returns {void}
 */
function formOnFocusHandler() {
  return _regenerator2.default.wrap(function formOnFocusHandler$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.take)(_immutable.actionTypes.FOCUS);

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _actions.trackEvent)(_analytics.MESSAGE_TRACKING_QD_START));

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/**
 * Fetch watchFormOnFocusEvents Saga
 * @returns {void}
 */
function watchFormOnFocusEvents() {
  return _regenerator2.default.wrap(function watchFormOnFocusEvents$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constants.QD_ACTION_FETCH_PMT_METHODS_SUCCEDED, formOnFocusHandler);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}